import table from "assets/images/chart-images/table.png";
const associateEditors = [
        { id: "TCSLAE-T03t", name: "table", chartImage: table, v2: "Column", disabled: false, description: "AVERAGE" },
        { id: "TCSLAE-T04t", name: "table", chartImage: table, v2: "Row", disabled: false, description: "AVERAGE" },
        { id: "TCSLAE-T05t", name: "table", chartImage: table, v2: "Column", disabled: false, description: "MEDIAN" },
        { id: "TCSLAE-T06t", name: "table", chartImage: table, v2: "Row", disabled: false, description: "MEDIAN" },
        { id: "TCSLAE-T07t", name: "table", chartImage: table, v2: "Column", disabled: false, description: "STATISTICS" },
        { id: "TCSLAE-T20t", name: "table", chartImage: table, disabled: false, description: " " },
];

export default associateEditors;
